import { render, staticRenderFns } from "./currencies.vue?vue&type=template&id=122fa95e"
import script from "./currencies.vue?vue&type=script&lang=js"
export * from "./currencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports